<template>
  <vs-popup fullscreen :title="docTitle + ' Help Documentation'" :active.sync="docViewerToggle">
    <div class="markdownContainer" v-html="compiledMarkdown" />
  </vs-popup>
</template>

<script>
import { marked } from 'marked'
import axios from 'axios'

export default {
  name: 'AppDocViewer',
  data() {
    return {
      docViewerToggle: false,
      compiledMarkdown: '',
      docTitle: '',
    }
  },
  methods: {
    async fetchDocFromCMS(app) {
      this.compiledMarkdown = marked('')
      try {
        this.docTitle = app.name
        const { data } = await axios.get(`https://cms.cloudify.biz/api/lighthouse-docs?filters[slug][$eq]=${app.slug}`)

        this.compiledMarkdown =
          data.data.length > 0 ? marked(data.data[0].attributes.doc.replace(/\/uploads/g, 'https://cms.cloudify.biz/uploads')) : marked('No Document Found')
      } catch (err) {
        this.compiledMarkdown = marked('An error occurred while fetching the document')
        this.$rollbar.error('Error occured while fetching the document', { err })
      }
    },
  },
}
</script>

<style>
.markdownContainer h3 {
  margin-top: 0.2em;
  margin-bottom: 0.5rem;
}

.markdownContainer h4 {
  margin-top: 1em;
  margin-bottom: 1rem;
  font-weight: 700;
}

.markdownContainer p {
  margin-top: 0.5em;
  margin-bottom: 0.5em;
}

.markdownContainer {
  padding: 5px;
}

.markdownContainer img {
  width: 100%;
  border: 0.1em solid grey;
  border-radius: 10px;
  box-shadow: 0px 0px 2px 3px rgb(223, 223, 223);
  margin: 10px auto;
}
</style>
